import { http } from ".";

export async function requestDeleteAccount() {
  return http.delete("/delete-account/");
}
